<template>
  <HomeCommonLayout>
    <template #content>
      <RenewalContent>
        <SkillfitContent />
      </RenewalContent>
    </template>
  </HomeCommonLayout>
</template>

<script setup lang="ts">
import { useHead } from "#imports";
import SkillfitContent from "~~/codepresso-renewal/content/SkillfitContent.vue";
import { useSeoMeta } from "~/composables/useSeoMeta";

const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead({
  title: "SkillFit — 진단 결과가 곧 나만의 학습 계획이 되는 개인화 학습 | 코드프레소",
  meta: [
    { name: "description", content: "SkillFit. AI 진단 인터뷰가 현재 수준과 취약점을 찾고 학습 경로를 설계합니다. 강의를 보는 대신, 브라우저에서 직접 코드를 씁니다." },
    { name: "title", content: "SkillFit — 진단 결과가 곧 나만의 학습 계획이 되는 개인화 학습 | 코드프레소" },
    { name: "robots", content: "index,follow" },
    { property: "og:title", content: "SkillFit — 진단 결과가 곧 나만의 학습 계획이 되는 개인화 학습 | 코드프레소" },
    { property: "og:description", content: "SkillFit. AI 진단 인터뷰가 현재 수준과 취약점을 찾고 학습 경로를 설계합니다. 강의를 보는 대신, 브라우저에서 직접 코드를 씁니다." },
  ],
  link: [...getHreflangLinks.value, { rel: "canonical", href: getCanonical.value }],
});
</script>

<style>
/* renewal 의 임베드 빌드 산출물(codepresso-renewal/embed). 모든 셀렉터가
   `.renewal-root` 를 요구하므로 헤더·푸터로 새지 않는다.
   로딩 순서는 renewal 원본과 같게 main → 페이지 전용 → mobile 로 둔다. */
@import "../../codepresso-renewal/embed/css/main.css";
@import "../../codepresso-renewal/embed/css/pages/skillfit.css";
@import "../../codepresso-renewal/embed/css/mobile.css";
</style>
